import React from 'react'
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from '../components/Common/PageBanner'
import Footer from "../components/App/Footer"
import ServiceDetailsContentCustomSpreadsheets from '../components/ServiceDetails/ServiceDetailsContentCustomSpreadsheets'
 
const Details = () => {
    return (
        <Layout>
            <Navbar />
            <PageBanner
                pageTitle="Custom Spreadsheets" 
                homePageText="Home" 
                homePageUrl="/" 
                activePageText="Custom Spreadsheets" 
            />
            <ServiceDetailsContentCustomSpreadsheets />
            <Footer />
        </Layout>
    );
}

export default Details